<template>
  <div>
    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-model="formattedDate"
          :label="caption"
          prepend-icon="mdi mdi-calendar"
          readonly
          v-on="on"
          :disabled="isDisabled"
          :regular="isRegular"
          :solo="isSolo"
          :outlined="isOutlined"
          :filled="isFilled"
        ></v-text-field>
      </template>

      <v-card v-if="this.model.Time">
        <v-card-text class="px-0 py-0">
          <v-tabs fixed-tabs v-model="activeTab">
            <v-tab key="calendar">
              <v-icon>mdi-calendar</v-icon>
            </v-tab>
            <v-tab key="timer">
              <v-icon>mdi-timer</v-icon>
            </v-tab>
            <v-tab-item key="calendar">
              <v-date-picker
              v-model="date"
              no-title
              scrollable
              :min="minDate"
              :max="maxDate"
              :first-day-of-week="firstDayOfWeek"
              :type="datePickerMode"
            ></v-date-picker>
            </v-tab-item>
            <v-tab-item key="timer">
              <v-time-picker
                v-model="time"
                @change="invokeActionOnClick(model.GenerationOnChange, { value: $event })"
                format="24hr"
              ></v-time-picker>
            </v-tab-item>
          </v-tabs>
        </v-card-text>
      </v-card>

      <v-date-picker
        v-else
        v-model="date"
        no-title
        scrollable
        :min="minDate"
        :max="maxDate"
        :type="datePickerMode"
        :first-day-of-week="firstDayOfWeek"
        :disabled="isDisabled"
        @change="invokeActionOnClick(model.GenerationOnChange, { value: $event })"
        @input="menu = false"
      ></v-date-picker>
    </v-menu>
  </div>
</template>

<script>

import inputMixin from '../../mixins/input-mixin'
import baseMixin from '../../mixins/base-mixin'
import actionMixin from '../../mixins/actions-mixin'
import moment from 'moment'

export default {
  mixins: [inputMixin, baseMixin, actionMixin],
  data: () => ({
    menu: false,
    dateValue: '',
    timeValue: '',
    activeTab: 0
  }),
  computed: {
    firstDayOfWeek() {
      return moment.localeData(this.$i18n.locale).firstDayOfWeek()
    },
    datePickerMode() {
      if (this.model.Mode === 'month') {
        return this.model.Mode
      }
      return 'date'
    },
    caption() {
      return this.evaluateExpression(this.model.Caption)
    },

    // format: 'dd-mm-yyyy'
    minDate() {
      let value = this.getDataSourceField(this.model?.MinDate)

      if (!value) {
        return ''
      }

      let splitedDate = value.split('-')

      return `${splitedDate[2]}-${splitedDate[1]}-${splitedDate[0]}`
    },

    // format: 'dd-mm-yyyy'
    maxDate() {
      let value = this.getDataSourceField(this.model?.MaxDate)
      
      if (!value) {
        return ''
      }

      let splitedDate = value.split('-')

      return `${splitedDate[2]}-${splitedDate[1]}-${splitedDate[0]}`
    },

    date: {
      get() {
        if (!this.dateValue) {
          return this.dateValue
        }
        let val = this.dateValue
        if (this.model.Mode == 'month') {
          if (val.length == 6) {
            val = val.substr(0, 4) + '-' + val.substr(4)
          }
          return val
        }
        let parts = val.split('.')
        return `${parts[2]}-${parts[1]}-${parts[0]}`
        
      },
      set(value) {
        if (!value) {
          this.setDataSourceField(this.model.Value, value)
        }
        if (this.model.Mode == 'month' && value) {
          value = value.replace('-', '')
          if (this.model.Time) {
            this.dateValue = value
            this.setDataSourceField(this.model.Value, `${this.dateValue} ${this.timeValue}`)
            return
          }
          this.dateValue = value
          this.setDataSourceField(this.model.Value, value)

        } else {
          const date = new Date(value)
          const dateTimeFormat = new Intl.DateTimeFormat('ru')
          const [
            { value: day },
            ,
            { value: month },
            ,
            { value: year }
          ] = dateTimeFormat.formatToParts(date)
          if (this.model.Time) {
            this.dateValue = `${day}.${month}.${year}`
            this.setDataSourceField(this.model.Value, `${this.dateValue} ${this.timeValue}`)
          } else {
            this.dateValue = `${day}.${month}.${year}`
            this.setDataSourceField(this.model.Value, `${day}.${month}.${year}`)
          }
        }
      }
    },
    time: {
      get() {
        return this.timeValue
      },
      set(value) {
        if (!value) {
          return
        }
        this.timeValue = value
        this.setDataSourceField(this.model.Value, `${this.dateValue} ${this.timeValue}`)
      }
    },
    formattedDate: {
      get() {
        let val = this.getDataSourceField(this.model.Value)
        return val
      }
    }
  },
  mounted() {
    if (this.model.Time) {
      let time = this.getDataSourceField(this.model.Value).split(' ')[1]
      this.timeValue = time ? time : ''
      let date = this.getDataSourceField(this.model.Value).split(' ')[0]
      this.dateValue = date ? date : ''
    } else {
      this.dateValue = this.getDataSourceField(this.model.Value)
    }
  }
}
</script>

<style>
</style>